import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { memo, useContext, useMemo, } from 'react';
import styleUtils from '../../styles/styleUtils';
import theme from '../../styles/theme';
import { RadioInputStateContext } from '../../utils/InputStateContext';
const defaultProps = {
    checked: false,
    disabled: false,
};
const RadioIcon = ({ checked = defaultProps.checked, disabled = defaultProps.disabled, }) => {
    const { isHovering, } = useContext(RadioInputStateContext);
    const radioStyles = useMemo(() => (css `
        ${styleUtils.borderBox}
        ${styleUtils.transition('all')}
        background-color: ${theme.colors.gray100};
        border: ${checked
        ? css `${styleUtils.rem(6)} solid ${theme.colors.gray700}`
        : css `${styleUtils.rem(1)} solid ${theme.colors.gray500}`};
        border-radius: 50%;
        display: block;
        flex: 0 0 auto;
        height: ${styleUtils.rem(24)};
        width: ${styleUtils.rem(24)};
        ${!disabled && isHovering && css `
          border-color: ${theme.colors.gray700};
        `}
        ${disabled && css `
          background-color: ${theme.colors.gray200};
          border-color: ${theme.colors.gray400};
        `}
      `), [
        checked,
        disabled,
        isHovering,
    ]);
    return (_jsx("span", { css: radioStyles }));
};
const MemoizedRadioIcon = memo(RadioIcon);
export { MemoizedRadioIcon as RadioIcon };
// MC-1068 Temporary hack for Storybook.
export default RadioIcon;
